import { apiAction } from "@ROM-utils/actions";
import Api from "./api";

export const UPDATE = "user/api/UPDATE";

export function update(attributes, id) {
  return apiAction(UPDATE, Api.update(attributes, id));
}
